export default __webpack_public_path__ + "static/media/linkedin.e2b4abe0.svg";